import { useIMask } from 'react-imask';
import { FormControl, FormHelperText, FormLabel, OutlinedInput } from '@mui/material';
import { withControl } from '@features/effector-form/hoc/withControl';

type PropsEmail = {
  fullWidth?: boolean;
  placeholder?: string;
};

export const EmailControl = withControl<PropsEmail>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    fullWidth = false,
    placeholder = '',
    isError,
  }) => {
    const { ref } = useIMask(
      {
        mask: 'N@D.W',
        blocks: {
          W: {
            mask: /^\w+$/,
          },
          D: {
            mask: /^[a-zA-Z0-9-_]+$/,
          },
          N: {
            mask: /^[a-zA-Z0-9-_\.]+$/,
          },
        },
      },
      {
        onAccept: (data) => {
          if (data !== value) {
            setValue(data);
          }
        },
      }
    );

    return (
      <FormControl required={required} disabled={disabled} fullWidth={fullWidth}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <OutlinedInput
          inputRef={ref}
          value={value}
          type="email"
          readOnly={readOnly}
          disabled={disabled}
          fullWidth={fullWidth}
          placeholder={placeholder}
          error={isError}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
